export const slideData= [
    'slider/1.jpg',
    'slider/2.jpg',
    'slider/3.jpg',
    'slider/4.jpg',
    'slider/5.jpg',
    'slider/6.jpg',
    'slider/7.jpg',
    'slider/8.jpg',
    'slider/9.jpg',
    'slider/10.jpg',
    'slider/11.jpg'
]

export const sliderCaptionData = [
    {
        img: 'slider/9.jpg',
        caption: "The area in the house that is most comfortable.",
        describe:" You can watch folks you wouldn't have in your house amuse you in your living room thanks to the development of television."
    },
    {
        img: 'slider/1.jpg',
        caption: "Drawing Room",
        describe:"Regardless of how big or tiny your home is, think about hiring an interior designer. They give you a calm living atmosphere in addition to decorating your home."
    },
    {
        img: 'slider/2.jpg',
        caption:"House Interior",
        describe:"If you want to alter your way of life, start with redesigning your house's interior."
    }
]